/**
 * @module app.cs
 */

 import { FrameworkConfiguration } from 'aurelia-framework';
 import { CustomerServiceModule } from './module';

 export function configure(config: FrameworkConfiguration) {
     config
         .singleton(CustomerServiceModule.registrationKey, CustomerServiceModule);

     config.globalResources([
         // elements

         // elements/members

         // elements/providers

         // value-converters
     ]);
 }
